import i18Next from 'i18next';

export const getIncomeSourceOptions = () => [
  {
    value: 'EMPLOYEE',
    name: i18Next.t('education_employment:income_sources.employee'),
  },
  {
    value: 'ENTREPRENEUR',
    name: i18Next.t('education_employment:income_sources.entrepreneur'),
  },
  {
    value: 'SELF_EMPLOYED',
    name: i18Next.t('education_employment:income_sources.self_employed'),
  },
  {
    value: 'STUDENT',
    name: i18Next.t('education_employment:income_sources.student'),
  },
  {
    value: 'MATERNITY_LEAVE',
    name: i18Next.t('education_employment:income_sources.maternity_leave'),
  },
  {
    value: 'IN_HOUSEHOLD',
    name: i18Next.t('education_employment:income_sources.in_household'),
  },
  {
    value: 'UNEMPLOYED',
    name: i18Next.t('education_employment:income_sources.unemployed'),
  },
  {
    value: 'RETIRED_PENSIONER',
    name: i18Next.t('education_employment:income_sources.retiree'),
  },
  {
    value: 'OTHER',
    name: i18Next.t('education_employment:income_sources.other'),
  },
];

export const getEducationOptions = () => [
  {
    value: 'ELEMENTARY',
    name: i18Next.t('education_employment:education.elementary'),
  },
  {
    value: 'SECONDARY',
    name: i18Next.t('education_employment:education.secondary'),
  },
  {
    value: 'HIGH_SCHOOL',
    name: i18Next.t('education_employment:education.diploma'),
  },
  {
    value: 'BACHELOR',
    name: i18Next.t('education_employment:education.bachelor'),
  },
  {
    value: 'UNIVERSITY',
    name: i18Next.t('education_employment:education.university'),
  },
];

export const getOwnershipOptions = () => [
  {
    name: i18Next.t('finance:ownership_types.mortgage'),
    value: 'MORTGAGE',
  },
  {
    name: i18Next.t('finance:ownership_types.owned'),
    value: 'OWNED',
  },
  {
    name: i18Next.t('finance:ownership_types.collective'),
    value: 'COLLECTIVE',
  },
  {
    name: i18Next.t('finance:ownership_types.rent'),
    value: 'RENT',
  },
  {
    name: i18Next.t('finance:ownership_types.with_relatives'),
    value: 'WITH_RELATIVES',
  },
  {
    name: i18Next.t('finance:ownership_types.employer'),
    value: 'EMPLOYER',
  },
  {
    name: i18Next.t('finance:ownership_types.dormitory_or_hotel'),
    value: 'DORMITORY_OR_HOTEL',
  },
];
